module.exports = __webpack_public_path__ + "static/img/20250320008.49768b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320008.jpg
// module id = 5zxO
// module chunks = 0